import React from 'react';
import PropTypes from 'prop-types';
import Registration from './Registration';
import {compose, graphql} from 'react-apollo';
import RegisterMutation from 'gql/register.gql';
import {FormattedHTMLMessage} from "react-intl";
import {connect} from "react-redux";
import {setUser} from 'actions/user';
import {generateUrl, routes} from "helpers/routes";
import {Redirect} from "react-router-dom";
import {getStatusFromError} from "helpers/errors";

class RegistrationProvider extends React.Component {
    static propTypes = {
        register: PropTypes.func.isRequired,
        onSetUser: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.redirectToHomepage = this.redirectToHomepage.bind(this);
    }

    componentWillMount() {
        this.setState({
            status: null,
            processing: false,
            isVatPayer: false
        });
    }

    redirectToHomepage() {
        this.setState({redirect: generateUrl(routes.homepage)});
    }

    vatPayerChange(isVatPayer) {
        this.setState({
            isVatPayer
        });
    }

    submitForm(model) {
        const {register} = this.props;
        const {isVatPayer} = this.state;

        this.setState({
            processing: true,
        });

        register({
            variables: {
                operator: {
                    login: model.email,
                    password: model.password,
                    firstName: model.name,
                    lastName: model.surname,
                    phoneNum: model.phone,
                    contactPhoneNum: model.contactPhone,
                    identNum: model.identNum,
                    businessName: model.businessName,
                    businessAddress: model.businessAddress,
                    correspondenceAddress: model.correspondenceAddress,
                    vatPayer: isVatPayer,
                    taxIdentificationNumber: model.tin,
                    bankAccountNumber: model.ban,
                    website: model.www
                },
            }
        }).then(({data}) => {
            if (data.register.id) {
                this.setState({
                    processing: false,
                    status: {
                        type: 'success',
                        message: <FormattedHTMLMessage id="registration.completed" defaultMessage="Registration completed"
                                                       values={{contractUrl: data.register.contractPdfUrl}}/>
                    }
                })
            }
        }).catch(error => {
            this.setState({
                processing: false,
                status: getStatusFromError(error),
            });
        });
    }

    render() {
        const {redirect} = this.state;
        if (redirect) {
            return <Redirect to={redirect} push/>;
        }

        return <Registration loading={this.state.processing} status={this.state.status} onFormSubmit={::this.submitForm} onVatPayerChange={::this.vatPayerChange}/>
    }
}

const mapStateToProps = state => ({
    user: state.user,
});

const mapDispatchToProps = dispatch => ({
    onSetUser: user => dispatch(setUser(user)),
});

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    graphql(RegisterMutation, {name: 'register'})
)(RegistrationProvider);


// WEBPACK FOOTER //
// ./src/containers/Registration/index.jsx